<ng-container [ngTemplateOutlet]="customSecondaryToolbar() || defaultSecondaryToolbar">
</ng-container>

<ng-template #defaultSecondaryToolbar>
  <div id="secondaryToolbar" class="secondaryToolbar hidden doorHangerRight" [style.top]="secondaryToolbarTop()"
    [style.transform]="'scale(' + mobileFriendlyZoomScale() + ')'" [style.transformOrigin]="'right top'">
    <div id="secondaryToolbarButtonContainer" [style.maxHeight]="secondaryToolbarMaxHeight">
      @for (button of pdfShyButtonService.buttons; track button.id) {
      <button type="button" [id]="button.id" [ngClass]="button.cssClass | invertForSecondaryToolbar"
        [class.toggled]="button.toggled" class="secondaryToolbarButton" [title]="button.title"
        [attr.data-l10n-id]="button.l10nId || null"
        (click)="onClick($event, button.action, button.eventBusName, button.closeOnClick)"
        [attr.aria-label]="button.title" [disabled]="button.disabled">
        @if (button.image) {
        <span class="icon" role="img" aria-hidden="true" [attr.aria-label]="button.title"
          [innerHTML]="button.image | sanitizedHtml"></span>
        }
        @else {
        <span class="icon" role="img" aria-hidden="true" [attr.aria-label]="button.title"></span>
        }
        <span class="toolbar-caption" [attr.data-l10n-id]="button.l10nLabel || null">{{ button.title }}</span>
      </button>
      }
    </div>
  </div>
</ng-template>